import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { getForm, checkPrivilegeByToken } from 'y4/Falcon';
import AppContext from 'context/Context';
import MainContentHeader from './MainContentHeader';
import MainContentPanel from './MainContentPanel';
import MainContentCard from './MainContentCard';
import { isAuthorized } from 'y4/Authentication';
import { useTranslation } from 'react-i18next';
import y, { getQueries, getQuery } from 'y4/Utils';
import { initWinXinInPage } from 'y4/WeiXin';
import { post } from 'y4/Y4Api';
import axios from 'axios';
import _ from 'lodash';

const Rows = ({ form, rows }) => {
  return rows.map((row, r_index) => {
    return (
      <Row key={r_index} className={row.className}>
        {row.columns.map((column, c_index) => {
          if (column.panel) {
            return (
              <Col
                key={c_index}
                className={column.className}
                {...column.breakPoint}
              >
                <MainContentPanel form={form} panel={column.panel} />
              </Col>
            );
          } else if (column.rows) {
            return (
              <Col key={c_index}>
                <Rows form={form} rows={column.rows} />
              </Col>
            );
          } else {
            return null;
          }
        })}
      </Row>
    );
  });
};

const MainContent = () => {
  const {
    config: { corp }
  } = useContext(AppContext);
  const location = useLocation();
  const [form, setForm] = useState();
  const { t } = useTranslation('auth');
  const t_b67db5a6 = t('Need to login again');
  const t_173df27a = t('You have been forced to logout, please login again.');

  /**
   * Check redirect
   * @param {*} f form
   */
  const checkAndSetForm = function (f, params) {
    f.location = location;
    f.corp = corp;
    const cf_check = _.get(f, 'option.check');
    if (cf_check) {
      const p = y.merge(cf_check.params, params);
      var uq = getQueries(location.search);
      const q = y.merge(cf_check.queries, { form: f.code }, uq);
      post(cf_check.servlet, cf_check.command, p, q).then(rt => {
        if (rt.isOk() && _.isObject(rt.data)) {
          const redirect = _.get(rt, 'data.redirect');
          const other = _.get(rt, 'data.other');
          if (redirect) {
            //Show redirecting message
            setForm({
              errorTitle: redirect.title,
              errorDescription: redirect.message
            });
            //navigate(url, { replace: true }); don't work
            y.navigate(redirect.url, { other: y.rowToOther(other, false) });
          } else {
            //No redirect
            if (other) f.other = other;
            //Use header
            const header = _.get(rt, 'data.header');
            if (header) {
              y.setIfHas(header, 'title', f, 'headerTitle');
              y.setIfHas(header, 'description', f, 'headerDescription');
              y.setIfHas(header, 'button.title', f, 'headerButtonTitle');
              y.setIfHas(header, 'button.url', f, 'headerButtonUrl');
              y.setIfHas(header, 'button.target', f, 'headerButtonTarget');
            }
            //Execute script
            const script = _.get(rt, 'data.javascript');
            eval(script);
            //Show form
            setForm(f);
          }
        } else {
          if (rt.isNotOk()) {
            f.headerTitle = `${rt.id}:${rt.code}`.toUpperCase();
            f.headerDescription = rt.message;
          }
          setForm(f);
        }
      });
    } else {
      setForm(f);
    }
  };

  /**
   * Call checkAndSetForm untest
   * @param {*} f form
   * @param {*} user weixin user info
   */
  const checkAndSetWeiXinForm = function (f, user) {
    f.other = y.merge(f.other, user);
    checkAndSetForm(f, user);
  };

  /**
   * Show form
   * @param {*} form_code
   */
  const showForm = (form_code, params) => {
    getForm(form_code, params).then(f => {
      if (_.isEmpty(f)) {
        if (isAuthorized(corp)) {
          setForm({
            errorTitle: 'No form',
            errorDescription: `No form by code ${form_code}`
          });
        } else {
          setForm({
            errorTitle: t_b67db5a6,
            errorDescription: t_173df27a
          });
        }
      } else {
        if (_.isEmpty(f.rows) && _.isEmpty(f.headerTitle)) {
          f.errorTitle = 'No row';
          f.errorDescription = `No row in form, form code : ${form_code}`;
        } else if (_.isEmpty(f.headerTitle)) {
          let col_count = 0;
          f.rows.forEach(r => {
            col_count += r.columns.length;
          });
          if (col_count == 0) {
            f.errorTitle = 'No column';
            f.errorDescription = `No column in rows of form, form code : ${form_code}`;
          }
        }

        initWinXinInPage(
          f,
          wx_user => {
            checkAndSetWeiXinForm(f, wx_user);
          },
          () => {
            checkAndSetForm(f);
          },
          e => {
            setForm({
              errorTitle: e.title,
              errorDescription: e.description
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    const reg = new RegExp('/\\w+/content/(\\w+)/(\\w+)');
    const reg_result = reg.exec(location.pathname);
    const form_code = reg_result ? reg_result[1] : 'HOME';
    const page_type = reg_result ? reg_result[2] : 'main';

    if (page_type == 'embed') {
      const token = getQuery(location.search, 'token');
      axios.defaults.headers.common['token'] = token;
      checkPrivilegeByToken(reg_result[0], token).then(rt => {
        if (rt.isOk()) {
          showForm(form_code, {
            path: location.pathname,
            query: location.search
          });
        } else {
          setForm({
            errorTitle: 'Inaccessible',
            errorDescription: rt.message
          });
        }
      });
    } else {
      showForm(form_code, {
        path: location.pathname,
        query: location.search
      });
    }
  }, []);

  return (
    <>
      <MainContentHeader form={form} />
      {form &&
        (form.errorTitle ? (
          <MainContentCard title={form.errorTitle}>
            {form.errorDescription}
          </MainContentCard>
        ) : (
          <Rows form={form} rows={form.rows} />
        ))}
    </>
  );
};

export default MainContent;
